<template>
  <div class="grid-wrapper" :class="{'long_div':isToLong}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchGrid',
  data () {
    return {
      labelW: this.labelWidth
    }
  },
  mounted () {},
  props: {
    isToLong: {
      default: false
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
// 使用深度作用选择器 /deep/将父组件样式渗透到子组件中
.grid-wrapper {
  // display: grid;
  // grid-template-columns: repeat(3, 1fr);
  display: table;
  &.long_div{
    min-width:1280px;
  }
  & > div {
    width: calc( 100% / 3 - 10px);
    margin-right:5px;
    &:last-child{
      padding-left:17px;
    }
    ::v-deep .el-form-item__content {
      width: 72%;
      & > div > .mult_variety{
        ::v-deep .el-select {
          width: calc(50% - 3px) !important;
        }
      }
    }
    ::v-deep .el-input, ::v-deep .el-select {
      width: 100% !important;
    }
    ::v-deep .el-date-editor.el-range-editor {
      width: 100% !important;
      min-width: 100% !important;
    }
    ::v-deep .el-date-editor {
      width: calc(50% - 7px) !important;
      // min-width: 131px !important;
    }
  }
}
</style>
